export default __webpack_public_path__ + "static/media/open.553d159f.svg";